import { Injectable, Type } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import * as dialogs from '../../../assets/dialogs.json';

const DEFAULT = 'FALLBACK';

@Injectable({
    providedIn: 'root',
})
export class DialogConfigService {
    // Behaviour subjects
    private _dialogConfig$: BehaviorSubject<any> = new BehaviorSubject<any>({});
    private _dialogRef$: BehaviorSubject<any> = new BehaviorSubject<any>({ ref: new DynamicDialogRef(), uuid: '' });

    // Observable the different components can subscrive to
    public readonly dialogConfig$: Observable<any> = this._dialogConfig$.asObservable();
    public readonly dialogRef$: Observable<any> = this._dialogRef$.asObservable();

    close(): void {
        this._dialogConfig$.next(null);
    }

    show(component: Type<any>, configName: string, data: any = {}): string {
        let config: DynamicDialogConfig = this._getConfig(configName);
        config.data = data;
        // Définition d'un UUID pour chaque modale
        config.data.uuid = Math.floor(Math.random() * 1000000000).toString();
        setTimeout(() => {
            this._dialogConfig$.next({ component: component, config: config });
        }, 1);
        return config.data.uuid;
    }

    setDialogRef(uuid: string, ref: DynamicDialogRef) {
        this._dialogRef$.next({ ref: ref, uuid: uuid });
    }

    private _getConfig(configName: string): DynamicDialogConfig {
        const config = (dialogs as any)[configName];
        const defaultConfig = (dialogs as any)[DEFAULT];
        return {
            header: config['header'] !== undefined ? config['header'] : defaultConfig['header'],
            footer: config['footer'] !== undefined ? config['footer'] : defaultConfig['footer'],
            width: config['width'] !== undefined ? config['width'] : defaultConfig['width'],
            height: config['height'] !== undefined ? config['height'] : defaultConfig['height'],
            closeOnEscape: config['closeOnEscape'] !== undefined ? config['closeOnEscape'] : defaultConfig['closeOnEscape'],
            baseZIndex: config['baseZIndex'] !== undefined ? config['baseZIndex'] : defaultConfig['baseZIndex'],
            autoZIndex: config['autoZIndex'] !== undefined ? config['autoZIndex'] : defaultConfig['autoZIndex'],
            dismissableMask: config['dismissableMask'] !== undefined ? config['dismissableMask'] : defaultConfig['dismissableMask'],
            rtl: config['rtl'] !== undefined ? config['rtl'] : defaultConfig['rtl'],
            style: config['style'] !== undefined ? config['style'] : defaultConfig['style'],
            contentStyle: config['contentStyle'] !== undefined ? config['contentStyle'] : defaultConfig['contentStyle'],
            styleClass: config['styleClass'] !== undefined ? config['styleClass'] : defaultConfig['styleClass'],
            transitionOptions: config['transitionOptions'] !== undefined ? config['transitionOptions'] : defaultConfig['transitionOptions'],
            closable: config['closable'] !== undefined ? config['closable'] : defaultConfig['closable'],
            showHeader: config['showHeader'] !== undefined ? config['showHeader'] : defaultConfig['showHeader'],
            modal: config['modal'] !== undefined ? config['modal'] : defaultConfig['modal'],
            maskStyleClass: config['maskStyleClass'] !== undefined ? config['maskStyleClass'] : defaultConfig['maskStyleClass'],
            resizable: config['resizable'] !== undefined ? config['resizable'] : defaultConfig['resizable'],
            draggable: config['draggable'] !== undefined ? config['draggable'] : defaultConfig['draggable'],
            keepInViewport: config['keepInViewport'] !== undefined ? config['keepInViewport'] : defaultConfig['keepInViewport'],
            minX: config['minX'] !== undefined ? config['minX'] : defaultConfig['minX'],
            minY: config['minY'] !== undefined ? config['minY'] : defaultConfig['minY'],
            maximizable: config['maximizable'] !== undefined ? config['maximizable'] : defaultConfig['maximizable'],
            maximizeIcon: config['maximizeIcon'] !== undefined ? config['maximizeIcon'] : defaultConfig['maximizeIcon'],
            minimizeIcon: config['minimizeIcon'] !== undefined ? config['minimizeIcon'] : defaultConfig['minimizeIcon'],
            position: config['position'] !== undefined ? config['position'] : defaultConfig['position'],
            duplicate: config['duplicate'] !== undefined ? config['duplicate'] : defaultConfig['duplicate'],
        }
    }
}
